import React from "react";
import CssClasses from "./LayoutUnauthenticated.css";

const LayoutUnauthenticated = props => {
  return (
    <div className={CssClasses.container}>
      <span>Terminal nije prijavljen!</span>
      <br />
      <button
        className={CssClasses.btnClose}
        onClick={() => {
          if (window.cefCustomObject) {
            window.cefCustomObject.closeTheApp();
          }
        }}
      >
        ZATVORI
      </button>
    </div>
  );
};

export default LayoutUnauthenticated;



// WEBPACK FOOTER //
// ./src/HOCs/LayoutUnauthenticated/LayoutUnauthenticated.js